import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Nose = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="nose icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.3064 40.635C35.7773 40.3759 34.7392 39.9826 33.2602 39.9826C31.3338 39.9826 30.0252 41.0489 28.8707 41.9896C27.5416 43.0721 26.2865 44.0951 23.8765 44.0951C21.4664 44.0951 20.2108 43.0721 18.8822 41.9891C17.7278 41.0489 16.4191 39.9826 14.4927 39.9826C13.0137 39.9826 11.9751 40.3759 11.4465 40.635C10.0676 40.12 8.70487 38.9185 8.70487 36.1752C8.70487 31.8079 13.7267 29.2951 13.7749 29.2719C14.1054 29.1117 14.357 28.8234 14.4711 28.4739C15.3561 25.7593 15.9344 22.3853 16.4933 19.1216C17.7754 11.6405 19.1008 3.90508 23.8765 3.90508C28.6522 3.90508 29.9776 11.6405 31.2591 19.121C31.8185 22.3847 32.3963 25.7593 33.2818 28.4739C33.3949 28.8212 33.647 29.1096 33.9754 29.2702C34.0262 29.2951 39.0481 31.8079 39.0481 36.1752C39.0481 38.9185 37.6854 40.12 36.3064 40.635ZM35.6935 27.1258C34.9583 24.6936 34.4557 21.7588 33.925 18.6644C32.5223 10.4784 30.9324 1.2002 23.8765 1.2002C16.82 1.2002 15.2301 10.4784 13.8273 18.665C13.2972 21.7593 12.7946 24.6936 12.0594 27.1258C10.4771 28.0363 6 31.0652 6 36.1752C6 41.7359 10.1065 43.7088 13.6239 43.7088C14.74 43.7088 15.7635 43.5416 16.3326 43.4275C16.5896 43.6158 16.8633 43.8338 17.1733 44.0864C18.6572 45.2955 20.504 46.7999 23.8765 46.7999C27.2489 46.7999 29.0958 45.2955 30.5797 44.0864C30.8896 43.8338 31.1634 43.6158 31.4198 43.4275C31.9889 43.5416 33.0124 43.7088 34.129 43.7088C37.6459 43.7088 41.7529 41.7359 41.7529 36.1752C41.7529 31.0652 37.2758 28.0363 35.6935 27.1258Z"
    />
  </svg>
)
